module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"map":"Detaillierte Übersichtskarte","watch":"Schau Video"},"en":{"map":"Detailed overview map","watch":"Watch video"},"it":{"map":"","watch":""},"lt":{"map":"Detalus žemėlapis","watch":"Žiūrėti video įrašą"},"pl":{"map":"Szczegółowa mapa","watch":"Obejrzyj wideo"}}')
  delete Component.options._Ctor
}
